export default "assets/images/logo_white-69abc658.png";